jQuery(document).ready(function ($) {
    function elementInViewport(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while(el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.pageYOffset + window.innerHeight) &&
            left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset &&
            (left + width) > window.pageXOffset
        );
    }
    var $frame = $('#basic');
    var $wrap = $frame.parent();

    var frame = new Sly($frame, {
        horizontal: 1,
        itemNav: 'basic',
        smart: 1,
        activateOn: null,
        mouseDragging: 1,
        touchDragging: 1,
        releaseSwing: 1,
        startAt: 0,
        scrollBar: $wrap.find('.scrollbar'),
        scrollBy: 1,
        speed: 2200,
        elasticBounds: 1,
        easing: 'easeOutExpo',
        dragHandle: 1,
        dynamicHandle: false,
        clickBar: 1,
        scrollSource: document,
        scrollTrap: true,
        prev: $wrap.find('.prev'),
        next: $wrap.find('.next'),
    }, {
        move: function () {
            function setTransform(el, transform) {
                el.style.transform = transform;
            }

            var images = document.querySelectorAll('.frame ul li .HomeSlider-card .parallax-wrapper .HomeSlider-image');

            var currentPosition = frame.pos.cur;
            var endPosition = frame.pos.end;
            var imageWidth = endPosition / images.length;
            var ratio = currentPosition / imageWidth;
            var intersectionRatioValue;

            $('.frame ul li .HomeSlider-card .HomeSlider-image').each(function (index, image) {
                intersectionRatioValue = ratio - (index * 0.3);
                setTransform(image, `translateX(${intersectionRatioValue * 20}px)`);
            });

        }
    }).init();


    let nextButton = document.getElementById("next");
    nextButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        frame.toStart(frame.rel.activeItem);
    });
    let prevButton = document.getElementById("prev");
    prevButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        frame.toStart(frame.rel.activeItem);
    });

    $('.is_open').click(function () {
        $('body').toggleClass('hide-b');
        if ($("body").hasClass("hide-b")) {
            frame.set('scrollBy', 0);
        } else {
            frame.set('scrollBy', 1);
        }
    });

    function SlyDestroy() {
        if ($(window).width() < 991) {
            $frame.sly(false);
        } else {
            frame.init();
        }
    }

    SlyDestroy();

    $(window).resize(function () {
        SlyDestroy();
    });


})